module.exports = require('./AssigneeSelector')



// WEBPACK FOOTER //
// ./src/components/AssigneeSelector/index.js